module.exports = __webpack_public_path__ + "media/images/2-empty-fcc9826786687be7a1c408e228d11101.png";